import { Card, CardBody, Col } from "reactstrap";
import { LI, UL } from "../../../../AbstractElements";
import { SaleStatisticTitle } from "../../../../Constants/Constants";
import DashboardCommonHeader from "../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import ReactApexChart from "react-apexcharts";
import { OptionsRevenueOrder } from "../../../../Data/General/Dashboard/Ecommerce";

const SaleStatistic = () => {
  return (
    <Col lg="5" className="custom-order-2 box-col-5">
      <Card className="revenue-order">
        <DashboardCommonHeader title={SaleStatisticTitle} dropdownClass="dropdown-toggle" />
        <CardBody>
          <UL className="d-flex align-item-center gap-2 simple-list flex-row">
            <LI><span className="bg-primary"> </span>Pending</LI>
            <LI><span className="bg-secondary"> </span>Completed</LI>
          </UL>
          <div id="revenue-order" >
            <ReactApexChart options={OptionsRevenueOrder} series={OptionsRevenueOrder.series} height={304} type="line" />
         </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SaleStatistic;
